export default "__VITE_ASSET__CR3zYHS___"